var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useTheme, Typography, Stepper, Step, StepLabel, StepContent, Button, Box, } from '@mui/material';
import MaterialTable from '../../MaterialTable';
import { format, compareAsc } from 'date-fns';
import { weightFormat } from '../../../utils/format';
import { DeliveryRequestIcon } from '../../atoms/Icons';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 10px 20px;\n"], ["\n  margin: 10px 20px;\n"])));
var QontoStepIconRoot = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  height: 22px;\n  align-items: center;\n  & > .QontoStepIcon-circle {\n    width: 8px;\n    height: 8px;\n    margin-left: 8px;\n    border-radius: 50%;\n    background-color: currentColor;\n  }\n"], ["\n  display: flex;\n  height: 22px;\n  align-items: center;\n  & > .QontoStepIcon-circle {\n    width: 8px;\n    height: 8px;\n    margin-left: 8px;\n    border-radius: 50%;\n    background-color: currentColor;\n  }\n"])));
var DeliveryRequestList = function (_a) {
    var items = _a.items, warehouseItem = _a.warehouseItem, onStartEdit = _a.onStartEdit;
    var t = useTranslation().t;
    var theme = useTheme();
    var sortedItems = React.useMemo(function () {
        return items.sort(function (a, b) {
            return compareAsc(new Date(a.deliveryRequest.requestDate || a.deliveryRequest.createdAt), new Date(b.deliveryRequest.requestDate || b.deliveryRequest.createdAt));
        });
    }, [items]);
    var isEditable = React.useCallback(function (items) {
        return items.some(function (item) { return item.deliveryRequest.status === 'requested'; });
    }, [warehouseItem]);
    if (items.length === 0) {
        return React.createElement(Wrapper, null, t('messages.noDeliveryRequest'));
    }
    return (React.createElement(Wrapper, null,
        React.createElement(Stepper, { orientation: "vertical" }, sortedItems.map(function (item) {
            return (React.createElement(Step, { key: item.id, active: true, expanded: true },
                React.createElement(StepLabel, { StepIconComponent: function () {
                        return (React.createElement(QontoStepIconRoot, null, item.deliveryRequest.status === 'shipped' ? (React.createElement(DeliveryRequestIcon, { className: "QontoStepIcon-completedIcon", color: "success" })) : (React.createElement("div", { className: "QontoStepIcon-circle" }))));
                    } },
                    item.deliveryRequest.requestDate && (React.createElement(Typography, null, "".concat(t('labels.deliveryRequestFormRequestDate'), ": ").concat(item.deliveryRequest.requestDate))),
                    React.createElement(Typography, { variant: "subtitle1", color: item.deliveryRequest.status === 'shipped'
                            ? theme.palette.success.main
                            : theme.palette.secondary.main }, t("params.deliveryRequest.statuses.".concat(item.deliveryRequest.status)))),
                React.createElement(StepContent, null,
                    React.createElement(MaterialTable, { model: 'deliveryRequestItem', title: '', columns: [
                            {
                                field: 'quantity',
                                render: function (item) {
                                    return "".concat(item.quantity, "(").concat(weightFormat(parseFloat(item.warehouseItem.offer.bagSize) *
                                        item.quantity), ")");
                                },
                            },
                            {
                                title: t('params.deliveryRequest.createdAt'),
                                render: function (item) {
                                    return format(new Date(item.deliveryRequest.createdAt), 'yyyy-MM-dd HH:mm:ss');
                                },
                            },
                        ], data: [item], options: { minBodyHeight: 100 } }))));
        })),
        isEditable(items) && (React.createElement(Box, { sx: { mt: 1 } },
            React.createElement("div", null,
                React.createElement(Typography, { variant: "caption" }, t('pages.warehouseItems.editDeliveryRequest.caption'))),
            React.createElement(Button, { color: "success", variant: "contained", size: "small", onClick: function () { return onStartEdit(items); } }, t('pages.warehouseItems.editDeliveryRequest.button'))))));
};
export default DeliveryRequestList;
var templateObject_1, templateObject_2;
